<template>
  <div class="item-container">
    <Avatar
      class="avatar"
      :name="displayName(participant)"
      :thumb-url="participant.thumbUrl"
      :deleted-at="participant.deletedAt"
      @dblclick="copy(participant.email)"
    />
    <div class="text">
      <FriedH4
        >{{ displayName(participant) }}
        <span v-if="isCurrentUser">{{ `(${t('you')})` }}</span>
      </FriedH4>
      <div class="title-container">
        <FriedLabel size="medium">{{ participant.title }}</FriedLabel>
        <template v-if="isOwner">
          <FriedLabel v-if="participant.title" class="title-divider" size="medium">{{
            ' | '
          }}</FriedLabel>
          <FriedLabel size="medium">{{ t('dr_room_owner') }}</FriedLabel>
        </template>
      </div>
    </div>
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import copy from 'copy-to-clipboard';
import type { Participant } from '../types';
import AvatarHelper from '../helpers/avatar.helper';
import Avatar from './Avatar.vue';

export default defineComponent({
  components: {
    Avatar,
  },
  props: {
    participant: {
      type: Object as PropType<Participant>,
      default: () => ({}),
    },
    isCurrentUser: {
      type: Boolean,
    },
    isOwner: {
      type: Boolean,
    },
  },
  setup() {
    const { t } = useI18n();
    return {
      displayName: AvatarHelper.getDisplayName,
      t,
      copy,
    };
  },
});
</script>

<style lang="scss" scoped>
.item-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-grow: 1;

  .avatar {
    margin-right: var(--spacing-75);
  }

  .text {
    display: flex;
    flex-direction: column;

    .title-divider {
      color: var(--gray-49);
    }
  }
}
</style>
